import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const AccountManagementUserGroupStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const AccountManagementUserGroupContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountManagementUserGroupStateContext.Provider value={stateHook}>
      {children}
    </AccountManagementUserGroupStateContext.Provider>
  );
};

export default AccountManagementUserGroupContextProvider;